import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { traceFunction, tagError, setTag } from "@core/datadog-server";
var STORYBLOK_BFF_URL = "".concat(readFromEnv(Env.StoryblokBFFComponent));
function getTagsfn() {
    return _getTagsfn.apply(this, arguments);
}
function _getTagsfn() {
    _getTagsfn = _async_to_generator(function() {
        var params, url, request, ref, data, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = new URLSearchParams({
                        cv: Date.now().toString()
                    });
                    url = "".concat(STORYBLOK_BFF_URL, "/get-tags?").concat(params.toString());
                    setTag("request.url", url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url)
                    ];
                case 2:
                    request = _state.sent();
                    setTag("request.url", url);
                    setTag("request.params", Object.fromEntries(params.entries()));
                    setTag("request.method", "GET");
                    setTag("request.status", request.status);
                    setTag("request.content-length", (ref = request.headers.get("content-length")) !== null && ref !== void 0 ? ref : "0");
                    return [
                        4,
                        request.json()
                    ];
                case 3:
                    data = _state.sent();
                    return [
                        2,
                        data.tags
                    ];
                case 4:
                    error = _state.sent();
                    if (typeof error === "string" || _instanceof(error, Error)) {
                        tagError(error);
                    }
                    throw new Error("get tags endpoint not working");
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _getTagsfn.apply(this, arguments);
}
export var getTags = traceFunction("storyblok.getTags", getTagsfn);
